// NewProviderRequestForm.js
import React, { useState, useEffect } from "react";
import { API_IP } from "../../env";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal"; // Import Modal
import ListGroup from "react-bootstrap/ListGroup"; // Use ListGroup for a cleaner look
import ButtonGroup from "react-bootstrap/ButtonGroup";
// Accept 'show' and 'onHide'
function NewProviderRequestForm({
  show,
  onHide,
  setRefreshProvider,
  refreshProvider,
}) {
  const [requestList, setRequestList] = useState([]);

  async function axiosReqConfig(url, method, data) {
    // ... (axiosReqConfig is the same)
    const bearerToken = localStorage.getItem("@uphealth_login_token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: data,
    };
    const returnData = await axios(reqConfig);
    return returnData;
  }

  async function getRequestsFromNewProvider() {
    try {
      const providerRequests = await axiosReqConfig(
        `${API_IP}/api/admin/providers/requests`,
        "get"
      ); //
      setRequestList(providerRequests.data);
    } catch (err) {
      console.error("Failed to fetch requests", err);
    }
  }

  async function AcceptOrDeclineRequest(response, providerID) {
    var answer = window.confirm(
      `Are you sure you want to ${
        response ? "accept" : "decline"
      } this provider?`
    );
    if (answer) {
      await axiosReqConfig(`${API_IP}/api/admin/providers/requests`, "post", {
        response: response,
        providerID: providerID,
      }); //
      // Refresh list after action
      getRequestsFromNewProvider();
      setRefreshProvider(!refreshProvider);
    }
  }

  useEffect(() => {
    // Fetch requests when modal is shown
    if (show) {
      getRequestsFromNewProvider();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>New Provider Requests</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup variant="flush">
          {requestList.length > 0 ? (
            requestList.map((provider) => (
              <ListGroup.Item key={provider.provider_id}>
                <Row className="align-items-center">
                  <Col>
                    <div className="fw-bold">{provider.provider_name}</div>
                    <div className="small text-muted">
                      {provider.email} | {provider.phone_number}
                    </div>
                    <div className="small text-muted">
                      {provider.address}, {provider.city}, {provider.province}
                    </div>
                  </Col>
                  <Col xs="auto">
                    <ButtonGroup>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => {
                          AcceptOrDeclineRequest(true, provider.provider_id);
                        }}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => {
                          AcceptOrDeclineRequest(false, provider.provider_id);
                        }}
                      >
                        Decline
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))
          ) : (
            <p>No new provider requests.</p>
          )}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NewProviderRequestForm;
